<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="page_6"></a>ABBREVIATIONS</h2>
<p class="hang">ACDS = Advanced Combat Data System</p>
<p class="hang">ACNS = Assistant Chief of the Naval Staff</p>
<p class="hang">ACO = Air Control Officer</p>
<p class="hang">ADA = Action Data Automation</p>
<p class="hang">ADAWS = ADA (<i>qv</i>) Weapons System</p>
<p class="hang">ADO = Air Defence Officer</p>
<p class="hang">ADNAD = Assistant Director Naval Air Department (Admiralty)</p>
<p class="hang">ADR = Aircraft Design Research (office in BuAer, USN)/Aircraft Direction Room (RN)</p>
<p class="hang">AESA = active electronically-scanned array</p>
<p class="hang">AEW = airborne early warning</p>
<p class="hang">AI = Air Intercept (radar); British designation for air-to-air radar</p>
<p class="hang">AIO = Action Information Organisation</p>
<p class="hang">AMCS = Airborne Missile Control System</p>
<p class="hang">APL = Applied Physics Laboratory</p>
<p class="hang">APO = Air Plot Officer</p>
<p class="hang">ARCI = Acoustic Rapid COTS (qv) Insertion</p>
<p class="hang">ARL = Admiralty Research Laboratory</p>
<p class="hang">AS = air-surface (radar)</p>
<p class="hang">ASE = Admiralty Signal Establishment</p>
<p class="hang">ASMS = Advanced Surface Missile System</p>
<p class="hang">ASV = Air to Surface Vessel (radar); British designation for sea-search radar</p>
<p class="hang">ASW = anti-submarine warfare</p>
<p class="hang">ASWE = Admiralty Surface Weapons Establishment</p>
<p class="hang">ATDS = Air Tactical Data System</p>
<p class="hang">BuAer = Bureau of Aeronautics (USN)</p>
<p class="hang">BuOrd = Bureau of Ordnance (USN)</p>
<p class="hang">BVP = Beacon Video Processor</p>
<p class="hang">CAL = Cornell Aeronautical Laboratory</p>
<p class="hang">CAM = Catapult Armed Merchant (ship)</p>
<p class="hang">CAP = combat air patrol</p>
<p class="hang">CCA = Carrier Controlled Approach</p>
<p class="hang">CDS = Comprehensive Display System/Combat Data System</p>
<p class="hang">CEP = Circular Error Probable</p>
<p class="hang">CIC = Combat Information Center</p>
<p class="hang">CICO = CIC (<i>qv</i>) Officer</p>
<p class="hang">CNA = Center for Naval Analyses</p>
<p class="hang">CNO = Chief of Naval Operations</p>
<p class="hang">CNR = Chief of Naval Requirements</p>
<p class="hang">CO = commanding officer</p>
<p class="hang">COC = Combat Operations Center</p>
<p class="hang">COD = Carrier-On-Board Delivery (aircraft)</p>
<p class="hang">COTS = commercial off-the-shelf (technology)</p>
<p class="hang">CW = Continuous Wave (as opposed to pulsed) radar, used mainly for missile homing (it is also used to measure the speeds of incoming aircraft for landing control)</p>
<p class="hang">DACR = Director Aircraft Carrier Requirements (Admiralty)</p>
<p class="hang">DADCAP = Dawn and Dusk Combat Air Patrol</p>
<p class="hang">DAE = Director of Air Equipment</p>
<p class="hang">DAM = Director of Air Material</p>
<p class="hang">DARPA = Department of Defense Advanced Research Projects agency</p>
<p class="hang">DAW = Director of Air Warfare (Admiralty)</p>
<p class="hang">DAWT = Director, Air Warfare and Training</p>
<p class="hang">DBR = dive bomber reconnaissance (aircraft)</p>
<p class="hang">DCAS = Deputy Chief of Air Staff</p>
<p class="hang">DCNO = Deputy Chief of Naval Operations</p>
<p class="hang">DDNAD = Deputy Director Naval Air Department (Admiralty)</p>
<p class="hang">DDR&amp;E = Directorate for Defense Research and Engineering</p>
<p class="hang">D/F = (radio) direction-finding</p>
<p class="hang">DLCO = Deck Landing Control Officer (RN equivalent of LSO [<i>qv</i>])</p>
<p class="hang">DLI = deck-launched interception/interceptor</p>
<p class="hang">DME = Distance Measuring Equipment</p>
<p class="hang">DNAD = Director of Naval Air Division</p>
<p class="hang">DNC = Department/Director of Naval Construction</p>
<p class="hang">DNO = Director of Naval Ordnance (Admiralty)</p>
<p class="hang">D of TD = Director of Tactical Division (Admiralty)</p>
<p class="hang">DPT = Digital Plot Transmission</p>
<p class="hang">DRT = Dead-Reckoning Tracer</p>
<p class="hang">DTD = Director of Technical Development</p>
<p class="hang">DTSD = Director, Training and Staff Duties Division</p>
<p class="hang">ECM = electronic countermeasures</p>
<p class="hang">EDS = Electronic Display System</p>
<p class="hang">FAA = Fleet Air Arm</p>
<p class="hang">FBC = Future Building Committee</p>
<p class="hang">FDB = fighter dive bomber (aircraft)</p>
<p class="hang">FFAR = folding-fin aerial rockets</p>
<p class="hang">FLIR = forward-looking infra-red</p>
<p class="hang">F/R = fighter/reconnaissance (aircraft)</p>
<p class="hang">FY = financial year</p>
<p class="hang">GAO = Government Accounting Office</p>
<p class="hang">GDR = Gun Direction Room</p>
<p class="hang">GP = general purpose (aircraft)</p>
<p class="hang">GPS = Global Positioning System</p>
<p class="hang">HACS = High Angle Control System</p>
<p class="hang">HEAF = High Energy Aircraft Fuel</p>
<p class="hang">HEF = High Energy Fuel</p>
<p class="hang">HF = High Frequency</p>
<p class="hang">HPI = Height Position Indicator (radar display)</p>
<p class="hang">HVAR = high-velocity aircraft rocket</p>
<p class="hang">IACS = Interceptor Armament and Control System</p>
<p class="hang">IFF = Identify Friend or Foe</p>
<p class="hang">JATO = jet-assisted take-off</p>
<p class="hang">LABS = Low-Altitude Bombing System</p>
<p class="hang">LAP = Low Altitude Performance</p>
<p class="hang">LOCAP = Low Altitude Combat Air Patrol</p>
<p class="hang">LPD = labelled plot displays</p>
<p class="hang">LRC = Long Range CAP (<i>qv</i>)</p>
<p class="hang">LROG = Long Range Objectives Group (USN)</p>
<p class="hang"><a id="page_7"></a>LSO = Landing Signals Officer</p>
<p class="hang">MADGE = Microwave Aircraft Digital Guidance Equipment</p>
<p class="hang">MADP = Main Air Display Plot</p>
<p class="hang">MAP = Ministry of Aircraft Production</p>
<p class="hang">MDAP = Mutual Defense Assistance Program</p>
<p class="hang">MDWP = Mutual Weapons Development Program</p>
<p class="hang">MEW = Microwave Early Warning (radar)</p>
<p class="hang">MMr = multi-mission radar</p>
<p class="hang">MNBO = Mobile Naval Base Organisation</p>
<p class="hang">MRC = Mid-Range CAP (<i>qv</i>)</p>
<p class="hang">MTDS = Marine Tactical Data System</p>
<p class="hang">MTI = moving target indication</p>
<p class="hang">NACA = National Advisory Committee on Aeronautics (US: predecessor of current NASA)</p>
<p class="hang">NAD = Naval Air Department (Admiralty)</p>
<p class="hang">NAF = Naval Aircraft Factory (USN)</p>
<p class="hang">NAMU = Naval Air Modification Unit</p>
<p class="hang">NASARR = North American Search and Range Radar</p>
<p class="hang">NAVAIR = Naval Air Systems Command (USN)</p>
<p class="hang">NDRC = National Defense Research Council</p>
<p class="hang">NEL = Naval Electronic Laboratory</p>
<p class="hang">NMBR = NATO Military Basic Requirement</p>
<p class="hang">NORAD = North American Air Defense</p>
<p class="hang">NOTS = Naval Ordnance Test Station</p>
<p class="hang">NRL = Naval Research Lab (USN)</p>
<p class="hang">NTDS = Naval Tactical Data System</p>
<p class="hang">OEG = Operational Evaluation Group</p>
<p class="hang">OFR = other fighter requirement</p>
<p class="hang">ONR = Office of Naval Research</p>
<p class="hang">OpDevFor = Operational Development Force</p>
<p class="hang">OpNav = Operations, Navy, i.e. the Office of the CNO (<i>qv</i>).</p>
<p class="hang">OpTevFor = Operational Test and Evaluation Force</p>
<p class="hang">OSD = Office of the Secretary of Defense</p>
<p class="hang">OSIS = Ocean Surveillance Information System</p>
<p class="hang">OSRD = Office of Scientific Research and Development</p>
<p class="hang">OTC = Officer in Tactical Command</p>
<p class="hang">OTH = over the horizon</p>
<p class="hang">P/A = pilotless aircraft</p>
<p class="hang">PCB = Plenum Chamber Burning (engine)</p>
<p class="hang">PIRAZ = Positive Identification Radar Advisory Zone</p>
<p class="hang">PMDS = projected map display system</p>
<p class="hang">PPBS = Planning, Programming, Budgeting System (US)</p>
<p class="hang">PPI = plan-position indicator</p>
<p class="hang">PSAC = President’s Science Advisory Committee</p>
<p class="hang">RAE = Royal Aircraft Establishment</p>
<p class="hang">RAF = Royal Air Force</p>
<p class="hang">RAFAD = Research Analysis of Fleet Air Defense</p>
<p class="hang">RAPCAP = Radar Picket Combat Air Patrol</p>
<p class="hang">RDF = radio direction-finding (i.e. radar)</p>
<p class="hang">RDR = Radar Display Room</p>
<p class="hang">RIO = radar intercept officer</p>
<p class="hang">RNAS = Royal Naval Air Service</p>
<p class="hang">ROTHER = Relocatable OTH (<i>qv</i>) Radar</p>
<p class="hang">R/T = radio telephone, i.e. voice radio</p>
<p class="hang">RVP = Radar Video Processor</p>
<p class="hang">SA = ship-to-air (radar)</p>
<p class="hang">SAAICS = Semi-Automatic Air Intercept Control System</p>
<p class="hang">SAC = Strategic Air Command</p>
<p class="hang">SADZAC = Semi-Automatic Digital Analyzer and Computer</p>
<p class="hang">SAGE = Semi-Automatic Ground Environment (System)</p>
<p class="hang">SAP = semi-armour-piercing (bomb)</p>
<p class="hang">SBR = Space Based Radar</p>
<p class="hang">SCS = Sea Control Ship</p>
<p class="hang">SEAM = Sidewinder Expanded Acquisition Mode</p>
<p class="hang">SINS = Ships Inertial Navigation System</p>
<p class="hang">SOR = Specific Operational Requirement</p>
<p class="hang">S/R = spotter/reconnaissance (aircraft)</p>
<p class="hang">SSPK = single-shot kill probability</p>
<p class="hang">SSS = Strike Support Ship</p>
<p class="hang">SWIP = Super Weight Improvement Programme</p>
<p class="hang">TAC = Tactical Air Command (USAF)</p>
<p class="hang">TACAN = Tactical Air Navigation</p>
<p class="hang">TBR = torpedo/bomber/reconnaissance (aircraft)</p>
<p class="hang">TBS = Talk Between Ships (radio)</p>
<p class="hang">TCS = television camera sight</p>
<p class="hang">TDP = Technical Development Plan</p>
<p class="hang">TSR = torpedo/spotter/reconnaissance (aircraft)</p>
<p class="hang">TWS = Track While Scan (radar)</p>
<p class="hang">VCNO = Vice Chief of the Naval Staff</p>
<p class="hang">VDP = Visual Direction Position</p>
<p class="hang">VSTOL = vertical/short take-off and landing</p>
<p class="hang">VTO = vertical take-off</p>
<p class="hang">VTOL = vertical take-off and landing</p>
<p class="hang">WA = Warning Air (radar set)</p>
<p class="hang">WDS = Weapon Direction System</p>
<p class="hang">WIP = Weight Improvement Programme</p>
<p class="hang">WSEG = Weapons System Evaluation Group</p>
<p class="hang">W/T = wireless telegraphy, i.e. Morse-code radio</p>
<p class="hang">ZELMAL = Zero-Length Launch Mattress Landing</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_abbre.vue?2d342647